// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/cloud.js';

import { paths } from '../generated/cloud';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('cloud', Original, paths);
